import {
  AppThunk,
  clearHotelCertificateIdFromStorage,
  clearCondoCertificateIdFromStorage,
} from '@share/utils';

import { filtersActions } from './filters';
import { condoFiltersActions } from './condo-filters';

/** Clears hotel + condo certificate ids from storage and filter slices (search / booking context). */
export const clearUserCertificateSearchContext = (): AppThunk => {
  return async (dispatch) => {
    clearHotelCertificateIdFromStorage();
    clearCondoCertificateIdFromStorage();
    dispatch(filtersActions.setCertificateId(''));
    dispatch(filtersActions.setHotelCertificateAllowAutoFill(true));
    dispatch(condoFiltersActions.setCertificateId(''));
    dispatch(condoFiltersActions.setCondoCertificateAllowAutoFill(true));
  };
};
